export interface IActionRequiredModalProps {
  open: boolean;
  onClose: () => void;
  products?: string[];
  limusPerformProducts?: string[];
  customerReference?: string;
  representativeReference?: string;
}

export enum ProductContext {
  photoID = 'photoID',
  limusPerform = 'limusPerform',
  multi = 'multi',
}
